import { ReactChild } from "react";
import classnames from "classnames";

type Props = {
  isActive: boolean;
  node: ReactChild;
  handleClick: () => void;
};
const CitiesNearby = ({ isActive, node, handleClick }: Props) => (
  <li
    className={classnames(
      "cities-nearby__tab py-xs border-solid border-b-2 border-deep-green-alt mr-lg text-center",
      {
        "border-deep-green": isActive,
        "text-green": !isActive,
      }
    )}
  >
    <button
      className="w-full font-bold focus:outline-none appearance-none"
      onClick={handleClick}
    >
      {node}
    </button>
  </li>
);

export default CitiesNearby;
